jQuery(document).ready(function(){
    // This button will increment the value
    $('.qtyplus').click(function(e){
        // Stop acting like a button
        e.preventDefault();
      
        // Get the field name
        fieldName = $(this).attr('field');
      var _div = $(this).parent().find($('input[name='+fieldName+']'));
      var _curr_val = $(this).parent().find($('input[name='+fieldName+']'));
        // Get its current value
        var currentVal = parseInt(_curr_val.val());
        // If is not undefined
        if (!isNaN(currentVal)) {
            // Increment
            _div.val(currentVal + 1);
        } else {
            // Otherwise put a 0 there
            _div.val(0);
        }
    });
    // This button will decrement the value till 0
    $(".qtyminus").click(function(e) {
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('field');
       var _div = $(this).parent().find($('input[name='+fieldName+']'));
      var _curr_val = $(this).parent().find($('input[name='+fieldName+']'));
        // Get its current value
        var currentVal = parseInt(_curr_val.val());
        // If it isn't undefined or its greater than 0
        if (!isNaN(currentVal) && currentVal > 0) {
            // Decrement one
            _div.val(currentVal - 1);
        } else {
            // Otherwise put a 0 there
             _div.val(0);
        }
    });
});